import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const customRoutes = [
  { method: "GET", path: "/summary", handlerName: "getPayrollSummary" },
  { method: "GET", path: "/batches", handlerName: "getPayrollBatchHistory" },
  { method: "GET", path: "/batches/:batchId", handlerName: "getPayrollBatchDetails" },
  { method: "PATCH", path: "/batches/:batchId", handlerName: "updatePayrollBatchStatus" },
];

const baseService = createCrudService("payroll", customRoutes, router);

export const payrollService = {
  ...baseService,

  exportPayroll: async (params) => {
    try {
      const response = await api.client.get('/api/payroll/export', {
        params,
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `payroll_${params.startDate}_to_${params.endDate}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return response;
    } catch (error) {
      // Handle error responses that come back as JSON even though we requested blob
      if (error.response && error.response.data) {
        // If it's a blob containing JSON error
        if (error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const errorData = JSON.parse(text);
            const errorMessage = errorData.message || 'Failed to export payroll';
            throw new Error(errorMessage);
          } catch (parseError) {
            // Only catch actual JSON parsing errors, not our intentional Error throws
            if (parseError.name === 'SyntaxError') {
              throw new Error('Failed to export payroll');
            } else {
              // Re-throw our intentional error
              throw parseError;
            }
          }
        }
        // If it's already parsed JSON
        else if (error.response.data.message) {
          throw new Error(error.response.data.message);
        }
      }

      // Handle 404 responses specifically
      if (error.response && error.response.status === 404) {
        const errorMessage = error.response.data?.message || 'No approved shifts found for the specified date range';
        throw new Error(errorMessage);
      }

      throw new Error(error.message || 'Failed to export payroll');
    }
  },

  downloadPayrollBatchCSV: async (batchId) => {
    const response = await api.client.get(`/api/payroll/batches/${batchId}/download`, {
      responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `payroll_batch_${batchId}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return response;
  },

  getClockedOutShifts: async (params) => {
    const response = await api.client.get('/api/payroll/clocked-out-shifts', {
      params
    });
    return response.data;
  }
};

export default payrollService;
